module.exports = __webpack_public_path__ + "media/images/pic/hero/bialoleka-49e4537e33a44ebb1925a2532bdfc288.png";